<template>
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="form-group col-sm-12 col-md-12 required">
              <label for="account_id">Account:</label>
              <Select2 name="account_id" v-model="account_id" :options="accountOptions"  @change="onChangeAccount($event)" @select="onChangeAccount($event)"/>
            </div>
            <div class="form-group col-sm-12 col-md-12 required">
              <label for="terminal_id">Device:</label>
              <Select2 name="terminal_id" v-model="terminal_id" :options="deviceOptions" />
            </div>
            <div class="form-group col-sm-12 col-md-6 required">
              <label for="from_date">From Date:</label>
              <input class="form-control" required type="date" v-model="from_date">
            </div>
            <TimeComponent :label="'From Time'" :selected_time="from_time" v-on:selected-time="setStart"/>
            <div class="form-group col-sm-12 col-md-6 required">
              <label for="to_date">To Date:</label>
              <input class="form-control" required type="date" v-model="to_date">
            </div>
            <TimeComponent :label="'To Time'" :selected_time="to_time" v-on:selected-time="setEnd"/>
            <div class="form-group col-sm-12">
              <input class="btn btn-primary" type="submit" value="Show" :disabled="this.onRequest">
            </div>
          </div>
        </form>
      </div>
      <div class="col-sm-12 mt-3">
        <Datatable v-bind:entries="this.report_passenger_flow" :columns="columns" :currEntries="100" :title="title"/>
      </div>
      <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
        <img :src="require('../assets/loading.gif')"/>
      </div>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment'
  import Datatable from '../components/Datatable.vue'
  import TimeComponent from '../components/TimeComponent.vue'
  import Select2 from 'vue3-select2-component';
  export default {
    computed: {
        ...mapState('accounts', ['accounts']),
        ...mapState('ceiba_devices', ['ceiba_devices']),
        ...mapState('report_passenger_flows', ['report_passenger_flow', 'onRequest']),
        title(){
          return 'Report Passenger Flow'
        }
    },
    data(){
      return {
        terminal_id: '',
        account_id: '',
        from_date: moment().format("YYYY-MM-DD"),
        from_time: '00:00',
        to_date: moment().format("YYYY-MM-DD"),
        to_time: '23:59',
        columns: [
          {name: 'time', text: 'Time', order: 'desc', raw:{
              type: 'Moment'
          }},
          {name: 'terid', text: 'Terminal ID'},
          {name: 'sitename', text: 'Site Name'},
          {name: 'open_time', text: 'Open Time', raw:{
              type: 'Moment'
          }},
          {name: 'close_time', text: 'Close Time', raw:{
              type: 'Moment'
          }},
          {name: 'door', text: 'Door'},
          {name: 'on', text: 'Passenger Get On'},           
          {name: 'off', text: 'Passenger Get Off'},     
        ],
        deviceOptions: [],
        accountOptions: [],
      }
    },
    methods: {
      handleSubmit(){
        if(this.onRequest) return;
        this.clear()
        const {terminal_id, from_date, from_time, to_date, to_time} = this
        let day = moment(this.from_date).diff(moment(this.to_date), 'days')
        if(day > 0){
          this.error('Please Input Correct Dates.')
          return;
        }

        // if(day < -3){
        //   this.error('Maximum Date Range is 3 days')
        //   return;
        // }
        let from_date_s = moment(from_date+ ' '+from_time).format('YYYY-MM-DD')
        let from_time_s = moment(from_date+ ' '+from_time).format('HH:mm:00')
        let to_date_s = moment(to_date+ ' '+to_time).format('YYYY-MM-DD')
        let to_time_s = moment(to_date+ ' '+to_time).format('HH:mm:00')

        this.get_data({terminal_id, from_date: from_date_s, from_time: from_time_s, to_date: to_date_s, to_time: to_time_s})
      },
      ...mapActions('accounts', ['get_all']),
      ...mapActions('ceiba_devices', {getData: 'get_ceiba_device_by_account'}),
      ...mapActions('report_passenger_flows', ['get_data', 'clear_data']),
      ...mapActions('alert', ['error', 'clear']),
      onChangeAccount(event){
        this.getData({account_id: parseInt(event.id)})
        this.terminal_id = ''
      },
      setStart(val){
        this.from_time = val
      },
      setEnd(val){
        this.to_time = val
      },
    },
    created() {
      this.$emit('onChildInit', 'Report Passenger Flow')
      this.clear_data()
      this.get_all()
    },
    components: {
      Datatable,
      TimeComponent,
      Select2,
    },
    watch: {
      ceiba_devices(nextState, prevState){
        if(nextState !== prevState){
          this.deviceOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.deviceOptions.push({id:item.terminal_id, text: item.terminal_id + (item.vehicle ? ' ' + (item.vehicle.vehicle_no +' - '+item.vehicle.vehicle_code) : '')})
            })
          }
          return
        }
      },
      accounts(nextState, prevState){
        if(nextState !== prevState){
          this.accountOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.accountOptions.push({id:item.id, text:item.account_name})
            })
          }
          return
        }
      },
    },
  }
</script>
